import { createCombinedLabelAndValue, createSingleLabelValue, createSingleLabelValueWithRemark, } from '../utils/create-combined-label-value';
import getTranslatedLabel from '../utils/get-tranlslated-label';
import { brakeSystemCollection, consumptionCollection, drivelineCollection, emissionCollection, emissionCollectionPHEV, engineCollection, insuranceCollection, landingGearCollection, noiseCollection, performanceCollectionCombustion, performanceCollectionElectric, performanceCollectionHybrid, roofLoadCollection, steeringSystemCollection, technicalDataCollectionCombustion, technicalDataCollectionElectric, technicalDataCollectionHybrid, tongueLoadCollection, trailerWeightCollection, volumeCollection, weightsCollection, } from './technical-data-collections';
function getFuelTypeTranslation(fuelType, i18n) {
    switch (fuelType) {
        case 'DIESEL':
            return i18n('compareLayer.technicalData.fuelType.diesel');
        case 'PETROL':
            return i18n('compareLayer.technicalData.fuelType.petrol');
        case 'ELECTRIC':
        case 'ELECTRICAL':
            return i18n('compareLayer.technicalData.fuelType.power');
        default:
            return '';
    }
}
export function getTechnicalDataItemsModel(td, market, driveTrain, i18n, translations) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    const engineData = td.items.find((item) => engineCollection.includes(item.key));
    const performanceData = driveTrain === 'PHEV'
        ? td.items.filter((item) => performanceCollectionHybrid.includes(item.key))
        : driveTrain === 'BEV'
            ? td.items.filter((item) => performanceCollectionElectric.includes(item.key))
            : td.items.filter((item) => performanceCollectionCombustion.includes(item.key));
    const technicalData = driveTrain === 'PHEV'
        ? td.items.filter((item) => technicalDataCollectionHybrid.includes(item.key))
        : driveTrain === 'BEV'
            ? td.items.filter((item) => technicalDataCollectionElectric.includes(item.key))
            : td.items.filter((item) => technicalDataCollectionCombustion.includes(item.key));
    const drivelineData = td.items.filter((item) => drivelineCollection.includes(item.key));
    const landingGearData = td.items.filter((item) => landingGearCollection.includes(item.key));
    const brakeSystemData = td.items.filter((item) => brakeSystemCollection.includes(item.key));
    const steeringSystemData = td.items.filter((item) => steeringSystemCollection.includes(item.key));
    const weightsData = td.items.filter((item) => weightsCollection.includes(item.key));
    const roofLoad = td.items.filter((item) => roofLoadCollection.includes(item.key));
    const tongueWeight = td.items.filter((item) => tongueLoadCollection.includes(item.key));
    const trailerWeightData = td.items.filter((item) => trailerWeightCollection.includes(item.key));
    const volumeData = td.items.filter((item) => volumeCollection.includes(item.key));
    const noiseData = td.items.filter((item) => noiseCollection.includes(item.key));
    const consumptionData = td.items.filter((item) => consumptionCollection.includes(item.key));
    const insuranceData = td.items.filter((item) => insuranceCollection.includes(item.key));
    const emissionData = driveTrain === 'PHEV'
        ? td.items.filter((item) => emissionCollectionPHEV.includes(item.key))
        : td.items.filter((item) => emissionCollection.includes(item.key));
    const fuelType = ((_c = (_b = (_a = td === null || td === void 0 ? void 0 : td.consumptionAndEmission) === null || _a === void 0 ? void 0 : _a.measurements) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.fuelType) &&
        createSingleLabelValue({
            label: i18n('compareLayer.technicalData.consumptionAndEmission.fuelType'),
            formattedValue: (_e = (_d = td.consumptionAndEmission) === null || _d === void 0 ? void 0 : _d.measurements) === null || _e === void 0 ? void 0 : _e.map((measurement) => getFuelTypeTranslation(measurement === null || measurement === void 0 ? void 0 : measurement.fuelType, i18n)).join(' - '),
        });
    if (fuelType) {
        emissionData === null || emissionData === void 0 ? void 0 : emissionData.push(fuelType);
    }
    const roofToungeLoads = market !== 'TW' &&
        roofLoad &&
        roofLoad.length > 0 &&
        tongueWeight &&
        tongueWeight.length > 0 &&
        createCombinedLabelAndValue({
            label: getTranslatedLabel(translations, (_g = (_f = roofLoad[0]) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.translationKey, (_j = (_h = roofLoad[0]) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.label),
            formattedValue: (_l = (_k = roofLoad[0]) === null || _k === void 0 ? void 0 : _k.item) === null || _l === void 0 ? void 0 : _l.formattedValue,
        }, {
            label: getTranslatedLabel(translations, (_o = (_m = tongueWeight[0]) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.translationKey, (_q = (_p = tongueWeight[0]) === null || _p === void 0 ? void 0 : _p.item) === null || _q === void 0 ? void 0 : _q.label),
            formattedValue: (_s = (_r = tongueWeight[0]) === null || _r === void 0 ? void 0 : _r.item) === null || _s === void 0 ? void 0 : _s.formattedValue,
        });
    if (roofToungeLoads) {
        weightsData === null || weightsData === void 0 ? void 0 : weightsData.push(roofToungeLoads);
    }
    return {
        engineData,
        performanceData,
        technicalData,
        drivelineData,
        landingGearData,
        brakeSystemData,
        steeringSystemData,
        weightsData,
        roofLoad,
        tongueWeight,
        trailerWeightData,
        volumeData,
        consumptionData,
        noiseData,
        insuranceData,
        emissionData,
    };
}
export function getTechnicalDataItemsConfiguredCar(td, market, driveTrain, i18n, translations) {
    var _a, _b, _c, _d, _e, _f, _g;
    const engineData = td.items.find((item) => engineCollection.includes(item.key));
    const performanceData = driveTrain === 'PHEV'
        ? td.items.filter((item) => performanceCollectionHybrid.includes(item.key))
        : driveTrain === 'BEV'
            ? td.items.filter((item) => performanceCollectionElectric.includes(item.key))
            : td.items.filter((item) => performanceCollectionCombustion.includes(item.key));
    const technicalData = driveTrain === 'PHEV'
        ? td.items.filter((item) => technicalDataCollectionHybrid.includes(item.key))
        : driveTrain === 'BEV'
            ? td.items.filter((item) => technicalDataCollectionElectric.includes(item.key))
            : td.items.filter((item) => technicalDataCollectionCombustion.includes(item.key));
    const drivelineData = td.items.filter((item) => drivelineCollection.includes(item.key));
    const landingGearData = td.items.filter((item) => landingGearCollection.includes(item.key));
    const brakeSystemData = td.items.filter((item) => brakeSystemCollection.includes(item.key));
    const steeringSystemData = td.items.filter((item) => steeringSystemCollection.includes(item.key));
    const weightsData = td.items.filter((item) => weightsCollection.includes(item.key));
    const roofLoad = td.items.filter((item) => roofLoadCollection.includes(item.key));
    const tongueWeight = td.items.filter((item) => tongueLoadCollection.includes(item.key));
    const trailerWeightData = td.items.filter((item) => trailerWeightCollection.includes(item.key));
    const volumeData = td.items.filter((item) => volumeCollection.includes(item.key));
    const noiseData = td.items.filter((item) => noiseCollection.includes(item.key));
    const consumptionData = td.items.filter((item) => consumptionCollection.includes(item.key));
    const insuranceData = td.items.filter((item) => insuranceCollection.includes(item.key));
    const emissionData = driveTrain === 'PHEV'
        ? td.items.filter((item) => emissionCollectionPHEV.includes(item.key))
        : td.items.filter((item) => emissionCollection.includes(item.key));
    const fuelType = ((_c = (_b = (_a = td === null || td === void 0 ? void 0 : td.consumptionAndEmission) === null || _a === void 0 ? void 0 : _a.measurements) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.fuelType) &&
        createSingleLabelValue({
            label: i18n('compareLayer.technicalData.consumptionAndEmission.fuelType'),
            formattedValue: (_e = (_d = td.consumptionAndEmission) === null || _d === void 0 ? void 0 : _d.measurements) === null || _e === void 0 ? void 0 : _e.map((measurement) => getFuelTypeTranslation(measurement === null || measurement === void 0 ? void 0 : measurement.fuelType, i18n)).join(' - '),
        });
    if (fuelType) {
        emissionData.push(fuelType);
    }
    const measurements = market.toUpperCase() !== 'DE'
        ? (_g = (_f = td.consumptionAndEmission) === null || _f === void 0 ? void 0 : _f.measurements[0]) === null || _g === void 0 ? void 0 : _g.consumption
        : null;
    if (measurements && measurements.length > 0) {
        measurements.forEach((measurement) => {
            var _a, _b, _c, _d, _e;
            if ((_a = measurement.phases) === null || _a === void 0 ? void 0 : _a.low) {
                emissionData.push(createSingleLabelValueWithRemark({
                    label: getTranslatedLabel(translations, measurement.phases.low.translationKey, measurement.phases.low.label),
                    formattedValue: measurement.phases.low.formattedValue || '',
                    remarks: measurement.phases.low.remarks,
                }));
            }
            if ((_b = measurement.phases) === null || _b === void 0 ? void 0 : _b.medium) {
                emissionData.push(createSingleLabelValueWithRemark({
                    label: getTranslatedLabel(translations, measurement.phases.medium.translationKey, measurement.phases.medium.label),
                    formattedValue: measurement.phases.medium.formattedValue || '',
                    remarks: measurement.phases.medium.remarks,
                }));
            }
            if ((_c = measurement.phases) === null || _c === void 0 ? void 0 : _c.high) {
                emissionData.push(createSingleLabelValueWithRemark({
                    label: getTranslatedLabel(translations, measurement.phases.high.translationKey, measurement.phases.high.label),
                    formattedValue: measurement.phases.high.formattedValue || '',
                    remarks: measurement.phases.high.remarks,
                }));
            }
            if ((_d = measurement.phases) === null || _d === void 0 ? void 0 : _d.extraHigh) {
                emissionData.push(createSingleLabelValueWithRemark({
                    label: getTranslatedLabel(translations, measurement.phases.extraHigh.translationKey, measurement.phases.extraHigh.label),
                    formattedValue: measurement.phases.extraHigh.formattedValue || '',
                    remarks: measurement.phases.extraHigh.remarks,
                }));
            }
            if ((_e = measurement.phases) === null || _e === void 0 ? void 0 : _e.city) {
                emissionData.push(createSingleLabelValueWithRemark({
                    label: getTranslatedLabel(translations, measurement.phases.city.translationKey, measurement.phases.city.label),
                    formattedValue: measurement.phases.city.formattedValue || '',
                    remarks: measurement.phases.city.remarks,
                }));
            }
        });
    }
    const roofToungeLoads = market.toLocaleUpperCase() !== 'TW' &&
        roofLoad &&
        roofLoad.length > 0 &&
        tongueWeight &&
        tongueWeight.length > 0 &&
        createCombinedLabelAndValue({
            label: getTranslatedLabel(translations, roofLoad[0].item.translationKey, roofLoad[0].item.label),
            formattedValue: roofLoad[0].item.formattedValue,
        }, {
            label: getTranslatedLabel(translations, tongueWeight[0].item.translationKey, tongueWeight[0].item.label),
            formattedValue: tongueWeight[0].item.formattedValue,
        });
    if (roofToungeLoads) {
        weightsData.push(roofToungeLoads);
    }
    return {
        engineData,
        performanceData,
        technicalData,
        drivelineData,
        landingGearData,
        brakeSystemData,
        steeringSystemData,
        weightsData,
        roofLoad,
        tongueWeight,
        trailerWeightData,
        volumeData,
        consumptionData,
        noiseData,
        insuranceData,
        emissionData,
    };
}
